//import {base} from '@airtable/blocks';

import ProcessingResult from "../../framework/ProcessingResult";

import Delay from "../../tools/Delay";

import PathSynchroApi from "../../api/PathSynchroApi";

// Substring the API returns (inside the ProblemDetails `detail`) when the customer agent
// that should run the synchro is not online. Kept in sync with the backend message.
export const AgentNotOnlineMarker = "Customer agent is not online";

const PathSynchroLogic = {

    PathSynchroAsync: async function (pathId: number, progress: any): Promise<ProcessingResult<string>> {

        const Timeout = 300 * 1000;

        let date = new Date();
        let timeout = date.getTime() + Timeout;

        let createRequestPathSynchroResult = await PathSynchroApi.CreateRequestPathSynchroAsync(pathId);

        if (createRequestPathSynchroResult.IsFailed()) {
            // Propagate the API message verbatim so the caller can classify it (e.g. offline agent).
            return ProcessingResult.Error(createRequestPathSynchroResult.ErrorMessage);
        }

        if (createRequestPathSynchroResult.Result.Accepted) {
            let token = createRequestPathSynchroResult.Result.Token;
            do {
                let getRequestPathSynchroResult = await PathSynchroApi.GetRequestPathSynchroAsync(token)

                if (getRequestPathSynchroResult.IsFailed()) {
                    return ProcessingResult.Error("Error in GetRequestPathSynchroAsync " + getRequestPathSynchroResult.ErrorMessage);
                }

                progress(getRequestPathSynchroResult.Result.Progress);

                if (getRequestPathSynchroResult.Result.Status === 4) {
                    return ProcessingResult.Ok(getRequestPathSynchroResult.Result.ErrorCode ?? "Unknown");
                }

                if (getRequestPathSynchroResult.Result.Status === 3) {
                    return ProcessingResult.Ok(getRequestPathSynchroResult.Result.ErrorCode ?? "Unknown");
                }

                await Delay.Sleep(500)
                date = new Date();
            }
            while (timeout > date.getTime())
            return ProcessingResult.Ok("TIMEOUT");
        }
        else {
            return ProcessingResult.Ok("OFFLINE");
        }
    }
};

export default PathSynchroLogic;